import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { ISearchService } from '@/services';
// @ts-ignore
import { ActivityStatus } from '@/common/enums';
import { SearchService } from '../../services';

export interface ISearchState extends IRootState<ISearchService> {
  contractors?: any;
  declarants?: any;
  owners?: any;
  managers?: any;
  caretakers?: any;
  salespersons?: any;
  independent_contractors?: any;
  status?: {
    contractors?: ActivityStatus;
    declarants?: ActivityStatus;
    managers?: ActivityStatus;
    caretakers?: ActivityStatus;
    independent_contractors?: ActivityStatus;
  }
}

export class SearchState extends RootState implements ISearchState {
  /**
   *
   */
  contractors?: any;
  declarants?: any;
  owners?: any;
  managers?: any;
  caretakers?: any;
  salespersons?: any;
  independent_contractors?: any;
  status?: {
    contractors?: ActivityStatus;
    declarants?: ActivityStatus;
    managers?: ActivityStatus;
    caretakers?: ActivityStatus;
    independent_contractors?: ActivityStatus;
  }
  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new SearchService;
    this.contractors = null;
    this.declarants = null;
    this.owners= null
    this.managers = null;
    this.caretakers = null;
    this.salespersons= null
    this.independent_contractors = null;
    this.status = {
      contractors: null,
      declarants: null,
      managers: null,
      caretakers: null,
      independent_contractors: null
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/search/search-state.store.ts